
import { defineComponent, PropType } from 'vue';
import { useControlCenterStore } from '../store';
import { LoadRobotPackagesStrategy } from './robotConnection/loadRobotPackages';
import { saveWorkspaceConnection } from '@/firebase/databaseDependencyInjectables';
import { LoadLaunchFilesStrategy } from './robotConnection/loadLaunchFilesStrategy';
import { IdleConnectionStrategy } from './robotConnection/robotConnection';

export default defineComponent({
  name: 'LoadPackagesPopup',
  data(): {
    commands: string;
    setupPath: string;
    loading: boolean;
    loadingText: string;
    loadingValue: number;
  } {
    return {
      commands: '',
      setupPath: '',
      loading: false,
      loadingText: 'Loading',
      loadingValue: 50
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    setVisible: {
      type: Function as PropType<
        (visible: boolean, finishedLoading?: boolean) => void
      >,
      required: true
    },
    // true if the package load is skipping already loaded packages
    loadMode: {
      type: Number,
      reuired: false,
      default: 1
    }
  },
  mounted() {
    const store = useControlCenterStore();
    if (store.currConnection) {
      this.commands = store.currConnection.connectionDetails.extraCommands;
    }
  },
  methods: {
    exit() {
      this.setVisible(false);
      this.loading = false;
    },
    onLoadPressed() {
      const store = useControlCenterStore();
      if (store.currConnection && store.workspaceId) {
        store.currConnection.connectionDetails.extraCommands = `export ROS_DOMAIN_ID=${
          store.currConnection.connectionDetails.domainId
        }\n${this.setupPath !== '' ? `source ${this.setupPath}\n` : ''}${
          this.commands
        }`;
        saveWorkspaceConnection(
          store.workspaceId,
          store.currConnection.connectionDetails
        );
        let loadStrategy: LoadLaunchFilesStrategy | LoadRobotPackagesStrategy =
          new LoadRobotPackagesStrategy(
            store.currConnection.connectionDetails.getSourceCommand(),
            this.loadMode === 2 || this.loadMode === 4,
            this.loadMode === 3 || this.loadMode === 4
          );
        store.currConnection?.setStrategy(loadStrategy);
        loadStrategy.loadProgressFunc = this.setLoadProgress;
        if (this.loadMode === 3 || this.loadMode === 4) {
          loadStrategy.whenFinished = () =>
            store.currConnection?.setStrategy(new IdleConnectionStrategy());
        } else {
          loadStrategy.whenFinished = () => {
            loadStrategy = new LoadLaunchFilesStrategy(
              store.currConnection?.connectionDetails.getSourceCommand()!,
              this.loadMode === 2 || this.loadMode === 4,
              this.loadMode !== 3 && this.loadMode !== 4
            );
            loadStrategy.whenFinished = () => {
              store.currConnection?.setStrategy(new IdleConnectionStrategy());
            };
            store.currConnection?.setStrategy(loadStrategy);
            loadStrategy.loadProgressFunc = this.setLoadProgress;
          };
        }
      }
      this.setVisible(false);
      this.loadingValue = 0;
      this.loadingText = 'Loading Packages From Robot';
      this.loading = true;
    },
    setLoadProgress(text: string, value: number, close: boolean = false) {
      this.loadingText = text;
      this.loadingValue = value;
      if (close) {
        this.setVisible(false, true);
        this.loading = false;
      }
    }
  }
});
